import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { setAuth0TokenGetter } from '../utils/auth0Token';

// Provider that makes getAccessTokenSilently available outside React components
export const Auth0TokenProvider = ({ children }) => {
	const { getAccessTokenSilently, isLoading, isAuthenticated } = useAuth0();

	// Store the function globally so it can be used in baseQuery
	// Set it immediately when available - don't wait for isLoading to be false
	// The function is available even while Auth0 is loading
	useEffect(() => {
		if (getAccessTokenSilently) {
			console.log('✅ Auth0TokenProvider: Setting token getter', {
				isLoading,
				isAuthenticated,
				hasFunction: !!getAccessTokenSilently
			});
			setAuth0TokenGetter(getAccessTokenSilently);
		}
		// Always set it if available, even if Auth0 is still loading
		// This allows baseQuery to get tokens as soon as they're available
	}, [getAccessTokenSilently]);

	return <>{children}</>;
};
